/* global DISPLAY_DATE_FORMAT */
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import Helmet from 'react-helmet'
import dayjs from 'dayjs'
import { orderDetailDispatchers as dispatchers } from 'reduxModules/users/dispatchers'
import { settledOrderSelector as selector } from 'reduxModules/users/selectors'
import { OrderDetail } from '../generic/OrderDetail'
import PaymentMethodDetails from '../generic/PaymentMethodDetails'
import AddressDetails from '../generic/AddressDetails'
import './styles.css'

export const Receipt = ({ items = [], loggedInFromEmail = false, ...props }) => {
  const { shippingAddress, billingAddress, creditCard: creditCardPayment, paypalAccount: paypalPayment } = props
  return (
    <div id="Receipt">
      <Helmet>
        <title>Receipt | Stan Winston School of Character Arts</title>
      </Helmet>
      <div className="your-receipt">
        <div className="wrapper">
          <h1>your receipt</h1>
        </div>
      </div>
      <div className="hero">
        <div className="icon">
          <i className="icon-check" />
        </div>
        <div className="message">
          <span>Your order has been placed</span>
        </div>
        <div className="thanks">
          <span>Thank you for shopping at Stan Winston School of Character Arts</span>
        </div>
      </div>
      <div className="order-background">
        <div className="order-container wrapper">
          <div className="column">
            <div className="row">
              <div className="order-number">
                <span className="accent">order number: </span>
                <span>{props.braintreeId}</span>
              </div>
              <div className="order-date">
                <span className="accent">date: </span>
                <span>{dayjs(props.created).format(DISPLAY_DATE_FORMAT)}</span>
              </div>
            </div>
            {!_.isEmpty(shippingAddress) && (
              <div className="ship-to row">
                <div className="subheader">
                  ship to
                </div>
                {props.deliveryMethod && <AddressDetails {...shippingAddress} />}
                {props.deliveryMethod && (
                  <div>
                    <span className="accent">Delivery: </span>
                    <span>{`${props.deliveryMethod.name} ${props.deliveryMethod.description}`}</span>
                  </div>
                )}
              </div>
            )}
            <div className="bill-to row">
              {(!_.isEmpty(billingAddress) || !_.isEmpty(creditCardPayment) || !_.isEmpty(paypalPayment)) && (
                <div className="subheader">
                  bill to
                </div>
              )}
              {(!_.isEmpty(creditCardPayment) || !_.isEmpty(paypalPayment)) && (
                <PaymentMethodDetails
                  creditCardPayment={creditCardPayment}
                  paypalPayment={paypalPayment}
                  width={props.width}
                />
              )}
              {billingAddress && !_.isNull(billingAddress.firstName) && (
                <>
                  <div className="small-subheader">
                    <span>billing address</span>
                  </div>
                  <AddressDetails {...billingAddress} />
                </>
              )}
            </div>
          </div>
          <div className="order-details-table">
            <OrderDetail {...props} items={items} isLoaded />
          </div>
        </div>
      </div>
    </div>
  )
}

Receipt.propTypes = {
  loadOrderDetail: PropTypes.func.isRequired,
  invalidAuth: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ),
  loggedInFromEmail: PropTypes.bool
}

export default connect(selector, dispatchers)(Receipt)
